// extracted by mini-css-extract-plugin
module.exports = {"tilesContainer":"TilesBoard_tilesContainer__TuDRY"};